import { useTranslate } from '@festina-life/ui/hooks'
import { FilterCheckbox } from '@festina-life/ui/listsAndTables'
import { Icon } from '@festina-life/ui/structure'

import { PreferencesMenu } from '../../components/pareferencesMenu/PreferencesMenu'
import { useLayoutContext } from '../../context/layoutContext'

export const ParameterViewPreferencesMenu = () => {
  const { preferences, onChangeView } = useLayoutContext()
  const translate = useTranslate()

  return (
    <PreferencesMenu
      trigger={
        <>
          {translate('parameterViewer.topBar.optionsPopover.button')}
          <Icon name="ChevronDown" className="ml-2" />
        </>
      }
      panelClassName="w-sm"
    >
      <div className="flex flex-col gap-y-2">
        <FilterCheckbox
          label={translate('parameterViewer.topBar.option.useModal')}
          id="useModal"
          checked={!!preferences.common.isUsingModal}
          onChange={() =>
            onChangeView({
              ...preferences,
              common: {
                ...preferences.common,
                isUsingModal: !preferences.common.isUsingModal,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate(
            'parameterViewer.topBar.option.showHoverDocumentation',
          )}
          id="showHoverDocumentation"
          checked={!!preferences.common.isShowingDocumentationOnHover}
          onChange={() =>
            onChangeView({
              ...preferences,
              common: {
                ...preferences.common,
                isShowingDocumentationOnHover:
                  !preferences.common.isShowingDocumentationOnHover,
              },
            })
          }
        />
        <FilterCheckbox
          label={translate(
            'parameterViewer.topBar.option.showExtrinsicParameterValues',
          )}
          id="showExtrinsicParameterValues"
          checked={!!preferences.parameters.isShowingExtrinsicParameterValues}
          onChange={() =>
            onChangeView({
              ...preferences,
              parameters: {
                ...preferences.parameters,
                isShowingExtrinsicParameterValues:
                  !preferences.parameters.isShowingExtrinsicParameterValues,
              },
            })
          }
        />
      </div>
    </PreferencesMenu>
  )
}
